import { useEffect, useState } from "react"
import Send from "../../core/communication"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { customToast } from "../../components/Toast"
import { useCopyClipBoard } from "../../core/utils/hooks/copyToClipBoard"
import { cadastroGeral } from "../../core/mocks/farmerProfile"
import FarmerProfileScreen from "../../screen/FarmerProfileScreen"
import { formatUsers, getSteps, groupFormStepsByCategory } from "../../core/utils/farmProfile"
import { FarmerProfileProvider, useFarmerProfile } from "../../core/context/farmerProfileContext"
import { useChatContext } from "../../core/context/chatContext"
import {
  AssistancePlanContextProvider,
  useAssistancePlanContext,
} from "../../core/context/assistancePlanContext"
import NewModalAlert from "../../components/NewModalAlert"
import moment from "moment"
import { useDispatch, useSelector } from "react-redux"
import { setData } from "../../core/redux/app/Actions"
import { useProjects, useScope } from "../SelectProjectCompanyContainer"
import { useUsers } from "../../core/utils/hooks/useUsers"

const tabOptions = [
  { value: 1, label: "Atendimentos" },
  { value: 2, label: "Plano de Ação" },
  { value: 3, label: "Indicadores", showOnlyEsm: true },
  { value: 4, label: "Formulários" },
  { value: 5, label: "Cadastro" },
  { value: 6, label: "Geolocalização" },
]

const getUserDetails = async (userId, state, setChat, projectId) => {
  try {
    if (state?.fromChat && userId) {
      return setChat(state?.fromChat)
    }

    if (state?.fromUsers && userId) {
      return setChat(state.fromUsers)
    }

    if (state?.frominitial && userId) {
      return setChat(state?.frominitial)
    }

    const response = await Send.get(`/users/user/${userId}`)

    if (!response?.length) {
      throw new Error("No user data found.")
    }

    const formattedUserDetails = { ...formatUsers(response[0]), projectId }

    const chat = state?.fromAssistanceList
      ? { ...state.fromAssistanceList, ...formattedUserDetails }
      : { ...state?.fromChat, ...formattedUserDetails }

    setChat(chat || {})
  } catch (error) {
    console.error("Error fetching user details: ", error)
    customToast("Erro ao buscar informações do produtor.", "error")
  }
}

const FarmerProfileContainer = (props) => {
  const navigate = useNavigate()
  const { search: searchParamns, pathname } = useLocation()
  const { userId } = useParams()
  const { scope, scopeType } = useScope()
  const { changeScope } = useProjects()
  const { state } = useLocation()
  const {
    isScheduleOpen,
    isAssistanceOpen,
    handleOpenAssistanceStatus,
    handleCloseAssistanceStatus,
    resetPinnedMessages,
    setFixedMessage,
  } = useChatContext()
  const { resetAssistancePlanContext } = useAssistancePlanContext()
  const { cacheState, shouldRedirectToUsers, cachedProjectId } = useSelector((state) => state.app)
  const {
    mainCardStatus,
    hideMainCard,
    pageName,
    setPageName,
    hasBackButton,
    userDetails,
    setUserDetails,
  } = useFarmerProfile()
  const { reload } = useUsers()
  const [steps, setSteps] = useState(cadastroGeral?.steps || [])
  const [formStepsGrouped, setFormStepsGrouped] = useState([])
  const [formSteps, setFormSteps] = useState([])
  const [indicatorTabsOptions, setIndicatorTabsOptions] = useState([])
  const [generalScale, setGeneralScale] = useState(0)
  const [currentTab, setCurrentTab] = useState({ value: 1 })
  const [chat, setChat] = useState({})
  const [editedChatFields, setEditedChatFields] = useState({})
  const [editIndex, setEditIndex] = useState(null)
  const [accordionHeightRecalc, setAccordionHeightRecalc] = useState(false)
  const [loadingField, setLoadingField] = useState(false)
  const [loadingStepsIndicator, setLoadingStepsIndicator] = useState(false)
  const copyToClipBoard = useCopyClipBoard()
  const [valuesQuestions, setValuesQuestions] = useState({})
  const [isSystemChat, setIsSystemChat] = useState(false)
  const [hasAssistanceId, setHasAssistanceId] = useState(null)
  const [openFormFill, setOpenFormFill] = useState(false)
  const [allFields, setAllFields] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [formQuestionMessage, setFormQuestionMessage] = useState(null)
  const dispatch = useDispatch()
  const closeModalChat = useSelector((state) => state.app.closeModalChat)

  useEffect(() => {
    setEditedChatFields(chat)
  }, [chat])

  useEffect(() => {
    handleCloseModal()
  }, [closeModalChat])

  useEffect(() => {
    if (state?.tab) {
      setCurrentTab({ value: state.tab })
    }
  }, [state?.tab])

  useEffect(() => {
    setAllFields([])
    resetFarmerProfile()
    resetPinnedMessages()
    setFixedMessage([])
  }, [])

  useEffect(() => {
    if (!searchParamns?.includes("context") && pageName) {
      setPageName("Perfil do(a) beneficiário(a)")
    }
  }, [pageName])

  useEffect(() => {
    if (
      state ||
      cacheState ||
      (userId && !searchParamns?.includes("context")) ||
      searchParamns?.includes("projectId")
    ) {
      getUserDetails(
        userId,
        state || cacheState,
        setChat,
        searchParamns?.split("&projectId")[1] || cachedProjectId,
      )
      dispatch(setData({ cacheFarmerState: state }))
    }
  }, [userId, state, cacheState, cachedProjectId])

  useEffect(() => {
    hideMainCard(null, isScheduleOpen ? false : true)
  }, [isScheduleOpen])

  const handleEdit = (fieldEdit, stepId) => {
    setEditIndex(fieldEdit)

    if (currentTab.value !== 3) {
      let getData = Array.isArray(formSteps) && formSteps.find((fs) => fs?.id === stepId)

      if (getData && getData.formQuestions) {
        getData = getData.formQuestions?.find((fs) => fs?.id === fieldEdit)
        setAccordionHeightRecalc(true)
      }
    }
  }

  const handleOpenAssistance = (assistanceDetails, tab) => {
    setHasAssistanceId(assistanceDetails)
    handleOpenAssistanceStatus(chat, assistanceDetails?.index)
    navigate(
      `/farmer/profile/${chat?.id}?context=${assistanceDetails?.id || assistanceDetails
      }&category=${tab}`,
    )
  }

  const handleOpenFormFill = () => {
    setOpenFormFill(true)
  }

  const handleChangeChatField = (v, field = null) => {
    if (typeof v === "string") {
      setEditedChatFields((prev) => ({ ...prev, [v]: field }))
    } else {
      const { name, value } = v.target
      setEditedChatFields((prev) => ({ ...prev, [name]: value }))
    }
  }

  const onSaveAllItems = async () => {
    if (!valuesQuestions) {
      return
    }

    try {
      setLoadingField(true)

      const response = await Send.put(`/forms-submissions-question/edit-history`, {
        producerId: userId,
        allFields,
      })

      customToast("Resposta Atualizada com sucesso", "success")
      setAllFields([])
      loadIndicators()
    } catch (error) {
      console.log("Error -> ", error)
      customToast("Erro ao alterar campo", "error")
    } finally {
      setLoadingField(false)
      setEditIndex(null)
    }
  }

  const handleSaveFsq = async () => {
    if (!valuesQuestions) {
      return
    }

    const fsqId = Object.keys(valuesQuestions)[0]

    setAllFields((fields) =>
      fields
        .filter((item) => item.fsqId != fsqId)
        .concat({
          fsqId,
          value: valuesQuestions[fsqId],
          formId: valuesQuestions[`form-${fsqId}`],
          producerId: userId,
        }),
    )
    setEditIndex(null)
  }

  const handleSave = async (fieldEdit, answer, stepIndex) => {
    const { id, name, email, phone, whatsapp, state, address, counties, community, birthday } = chat
    const formattedUsers = {
      id,
      name,
      email,
      phone,
      whatsapp,
      state,
      address,
      counties,
      community,
      birthday,
    }

    try {
      setLoadingField(true)
      const response = await Send.put(`/users/${chat.id}`, {
        ...formattedUsers,
        [fieldEdit]:
          fieldEdit === "birthday" ? moment(answer, "DD/MM/YYYY").format("YYYY-MM-DD") : answer,
      })

      if (response && Object.keys(response)?.length > 0) {
        const updatedSteps = steps.map((step, index) =>
          index === stepIndex
            ? {
              ...step,
              fields: step.fields.map((field) =>
                field.field === fieldEdit ? { ...field, answer } : field,
              ),
            }
            : step,
        )

        setSteps(updatedSteps)
        setChat({ ...chat, ...response })
        customToast("Campo alterado com sucesso", "success")
        reload()
      } else {
        customToast("Erro ao alterar campo", "error")
      }
    } catch (error) {
      console.log("Error -> ", error)
      customToast("Erro ao alterar campo", "error")
    } finally {
      setLoadingField(false)
      setEditIndex(null)
    }
  }

  const handleCancel = () => {
    setEditIndex("")
  }

  const handleCopy = (e, answer) => {
    copyToClipBoard(`${answer}`, `Item copiado com sucesso`)
  }

  const handleActiveAccordion = (value) => { }

  const handleActiveIndicator = (value) => {
    console.log("DD", value)
    if (Array.isArray(value)) {
      setFormSteps(formStepsGrouped[value[0]?.label])
    } else {
      setFormSteps(formStepsGrouped[value?.label])
    }
  }

  const loadIndicators = async () => {
    try {
      setLoadingStepsIndicator(true)

      const response = await Send.get(
        `/scale-indicator/questions/${chat.id}/${scope?.id}`,
        `scopeType=${scopeType}`,
      )

      const { indicators, summary, details } = response

      const format = indicators.sort((a, b) => a.category.localeCompare(b.category))
      if (indicators?.length > 0) {
        setIndicatorTabsOptions(getSteps(format))
        setFormStepsGrouped(groupFormStepsByCategory(format))
      }

      setGeneralScale(details?.Geral.toFixed(0) || 0)
    } catch (error) {
      console.log("erro", error)
    } finally {
      setLoadingStepsIndicator(false)
    }
  }

  useEffect(() => {
    if (chat && chat?.id && chat?.projectUserHasEsm) {
      loadIndicators()
    }
  }, [chat])

  useEffect(() => {
    if (searchParamns && searchParamns.split("?context=")[1]) {
      let context = searchParamns.split("?context=")[1]
      context = context.split("&")[0]

      if (context !== "false") {
        setHasAssistanceId(isAssistanceOpen || true)
      } else {
        setHasAssistanceId(true)
      }
    }
  }, [searchParamns])

  useEffect(() => {
    if (!shouldRedirectToUsers) {
      //navigate("/users")
    }
  }, [shouldRedirectToUsers])

  /* useEffect(() => {
    if (Object.keys(formStepsGrouped).length > 0 && indicatorTabsOptions.length > 0) {
      setFormSteps(formStepsGrouped[indicatorTabsOptions[0].label])
    }
  }, [formStepsGrouped, indicatorTabsOptions]) */

  const onChangeQuestionsInfo = (type, value, fsqId, { formId, formQuestionId }) => {
    if (type === "checkbox") {
      let formattedValue = Array.isArray(value)
        ? [...new Set(value?.map((row) => `${row.label}`))]
        : value?.label

      formattedValue = Array.isArray(formattedValue)
        ? formattedValue.map((row, idx) => {
          const isTheLastPosition = idx !== value.length - 1

          return isTheLastPosition ? `${row}|` : row
        })
        : value

      formattedValue = formattedValue ? formattedValue.toString().replaceAll("|,", "|") : ""

      setValuesQuestions({
        [formQuestionId]: !formattedValue || formattedValue === "" ? "Ø" : formattedValue,
        [`form-${formQuestionId || "create"}`]: formId || "",
        [`formQuestion-${formQuestionId || "create"}`]: formId || "",
      })

      return
    }

    if (type === "radio" || type === "users" || type === "select") {
      const formattedData = Array.isArray(value)
        ? value?.map((row) => row.label).join("|")
        : value?.label

      setValuesQuestions({
        // ...valuesQuestions,
        [formQuestionId || "create"]: formattedData || "",
        [`form-${formQuestionId || "create"}`]: formId || "",
        [`formQuestion-${formQuestionId || "create"}`]: formId || "",
      })

      return
    }

    setValuesQuestions({
      // ...valuesQuestions,
      [formQuestionId]: value,
      [`form-${formQuestionId || "create"}`]: formId || "",
      [`formQuestion-${formQuestionId || "create"}`]: formId || "",
    })
  }

  const resetFarmerProfile = () => {
    setPageName("Perfil do(a) beneficiário(a)")
    setHasAssistanceId(undefined)
    handleCloseAssistanceStatus()
  }

  const handleGoBack = () => {
    const isContextInParams = searchParamns.includes("?context=")
    const isStepsInParams = /steps=([^&]+)/.test(searchParamns)
    const isFormInParams = searchParamns.includes("form")
    const isNotFormInParams = searchParamns.includes("form=&")
    const isNotStepsInParams = searchParamns.includes("steps=&")

    const hasCategorySchedule = searchParamns.includes("category=schedule")
    const hasCategoryNew = searchParamns.includes("category=new")
    const hasCategoryClosed = searchParamns.includes("category=closed")

    const hasCategory = hasCategorySchedule || hasCategoryNew || hasCategoryClosed
    const isNotCategory = !hasCategory

    const isBeneficiaryProfilePage = pageName === "Perfil do(a) beneficiário(a)"
    const hasNoSearchParams = !searchParamns

    const shouldRedirectToFarmerProfile =
      (isContextInParams && isStepsInParams) ||
      (isFormInParams && isNotStepsInParams) ||
      (isNotFormInParams && isNotStepsInParams) ||
      (isNotCategory && isNotStepsInParams)

    const confirmAndNavigateBack = async () => {
      await onSaveAllItems()
      resetFarmerProfile()
      navigate(-1)
    }

    const cancelAndNavigateBack = () => {
      resetFarmerProfile()
      navigate(-1)
    }

    if (allFields && allFields.length > 0) {
      NewModalAlert.warn({
        title: "Salve as alterações antes de sair!",
        confirmLabel: "Salvar",
        text: "Você fez alterações que não foram salvas. Clique em 'Salvar' para garantir que suas mudanças sejam registradas.",
        confirmButtonColor: "#3085d6",
        onConfirm: confirmAndNavigateBack,
        onCancel: cancelAndNavigateBack,
      })
    } else if (searchParamns?.includes("fromChatPage")) {
      resetFarmerProfile()
      navigate(`/chat`, { replace: true })
    } else {
      if (shouldRedirectToFarmerProfile) {
        resetFarmerProfile()
        hideMainCard(false, true)
        navigate(`/farmer/profile/${userId}`, { replace: true })
      } else if (isContextInParams && !isNotFormInParams) {
        resetFarmerProfile()
        hideMainCard(false, true)
        navigate(`/farmer/profile/${userId}`, { replace: true })
      } else if (isBeneficiaryProfilePage && hasNoSearchParams) {
        resetFarmerProfile()
        navigate(`/users`, { replace: true })
      } else if (isNotCategory) {
        resetFarmerProfile()
        navigate(`/farmer/profile/${userId}?${searchParamns}`, { replace: true })
      } else {
        setOpenFormFill(false)
      }
    }

    resetAssistancePlanContext()
    dispatch(setData({ assistanceCategory: false }))
  }

  const handleNavigate = () => {
    navigate(`/activity/history/farmer/${chat?.id}`, {
      state: {
        producer: chat?.name,
        creationUserDate: chat?.createdAt,
        projectId: chat?.projectId,
      },
    })
  }

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <FarmerProfileScreen
      {...{
        generalScale,
        noSearchParams: searchParamns,
        values: valuesQuestions,
        handleActiveAccordion,
        handleActiveIndicator,
        chat,
        steps,
        formSteps,
        handleEdit,
        editedChatFields,
        editIndex,
        handleSave,
        handleCancel,
        loadingField,
        loadingStepsIndicator,
        handleCopy,
        handleChangeChatField,
        onChangeQuestionsInfo,
        accordionHeightRecalc,
        tabOptions: tabOptions.filter((tab) => (!chat?.projectUserHasEsm ? !tab.showOnlyEsm : tab)),
        currentTab,
        setCurrentTab,
        indicatorTabsOptions,
        isSystemChat,
        setIsSystemChat,
        handleSaveFsq,
        formStepsGrouped,
        handleOpenAssistance,
        hasAssistanceId,
        mainCardStatus,
        handleGoBack,
        pageName,
        isScheduleOpen,
        isAssistanceOpen,
        resetFarmerProfile,
        handleOpenFormFill,
        openFormFill,
        hasBackButton,
        handleNavigate,
        allFields,
        onSaveAllItems,
        isModalOpen,
        handleOpenModal,
        handleCloseModal,
        formQuestionMessage,
        setFormQuestionMessage,
      }}
    />
  )
}

const FarmerProfile = () => {
  return (
    <FarmerProfileProvider>
      <AssistancePlanContextProvider>
        <FarmerProfileContainer />
      </AssistancePlanContextProvider>
    </FarmerProfileProvider>
  )
}

export default FarmerProfile
